// extracted by mini-css-extract-plugin
var _1 = "Link-modulebasic__o_atk";
var _2 = "Link-moduledisabled__SZYEs";
var _3 = "Link-modulelink__btW0L";
var _4 = "Link-modulesecondary__gGC0q";
var _5 = "Link-moduleunderline__Qnd2s";
export { _1 as "basic", _2 as "disabled", _3 as "link", _4 as "secondary", _5 as "underline" }
